/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import {
  IAdminAnswer,
  IModelData,
  IPrivateChatState,
} from "types/models/private-chat";
import { RootState } from "types/reducer";
import { create_UUID } from "utils";

const initialState: IPrivateChatState = {
  private_chat: {
    data: [],
    history: [],
    session_history: [],
    message: "",
    loading: false,
  },
  permission_tree: [],
  mess_welcome: {
    message: [],
    max_token: 0,
    words_remain: ''
  },
  llm_model: [],
  api_tree: [],
};

const PrivateChatSlice = createSlice({
  name: "private_chat",
  initialState,
  reducers: {
    fetchMessageWelcome(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) { },
    fetchMessageWelcomeSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) {
      state.private_chat = {
        ...state.private_chat,
        data: action.payload?.data?.message.map((mes: any) => {
          return {
            id: create_UUID(),
            time_request: moment().toString(),
            answer: mes,
            type: "out",
            username: "admin",
          };
        }),
        loading: false,
      };
      state.mess_welcome = {
        ...state.mess_welcome,
        message: action.payload?.data?.message.map((mes: any) => {
          return {
            id: create_UUID(),
            time_request: moment().toString(),
            answer: mes,
            type: "out",
            username: "admin",
          };
        }),
        max_token: action.payload.data.max_token,
        words_remain: action.payload.data.words_remain
      };
    },
    fetchMessageWelcomeFailure(state) {
      state.private_chat = {
        ...state.private_chat,
        data: [...state.private_chat.data],
        loading: false,
      };
    },
    fetchAnswer(
      state,
      action: PayloadAction<{ answer: string; checked: boolean; chat_page: string; check_documents: Array<string>; check_log_names: Array<string> }>
    ) {
      state.private_chat = {
        ...state.private_chat,
        data: [
          ...state.private_chat.data,
          {
            id: create_UUID(),
            time_request: moment().toString(),
            answer: action.payload.answer,
            type: "in",
            username: "User",
          },
        ],
        loading: true,
      };
    },
    fetchAnswerSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<IAdminAnswer & any>
    ) {
      state.private_chat = {
        ...state.private_chat,
        data: [
          ...state.private_chat.data,
          {
            id: create_UUID(),
            time_request: moment().toString(),
            answer: action.payload.answer,
            type: "out",
            username: "admin",
          },
        ],
        session_history: action.payload.chat_history ?? [],
        loading: false,
      };
      state.mess_welcome.words_remain = action.payload.words_remain
    },
    fetchAnswerFailure(state) {
      state.private_chat = {
        ...state.private_chat,
        data: [...state.private_chat.data],
        loading: false,
      };
    },
    fetchAnswerWebosAPI(
      state,
      action: PayloadAction<{ answer: string; checked: boolean; chat_page: string; check_documents: Array<string>; type: string }>
    ) {
      state.private_chat = {
        ...state.private_chat,
        data: [
          ...state.private_chat.data,
          {
            id: create_UUID(),
            time_request: moment().toString(),
            answer: action.payload.answer,
            type: "in",
            username: "User",
          },
        ],
        loading: true,
      };
    },
    fetchAnswerWebosAPISuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<IAdminAnswer & any>
    ) {
      state.private_chat = {
        ...state.private_chat,
        data: [
          ...state.private_chat.data,
          {
            id: create_UUID(),
            time_request: moment().toString(),
            answer: action.payload.answer,
            type: "out",
            username: "admin",
          },
        ],
        session_history: action.payload.chat_history ?? [],
        loading: false,
      };
      state.mess_welcome.words_remain = action.payload.words_remain
    },
    fetchAnswerWebosAPIFailure(state) {
      state.private_chat = {
        ...state.private_chat,
        data: [...state.private_chat.data],
        loading: false,
      };
    },
    fetchDataLLMModel() { },
    fetchDataLLMModelSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) {
      state.llm_model = action.payload.map((llm: IModelData) => {
        return {
          value: llm.label,
          label: llm.label,
          key: llm.value,
          no: llm.no,
          overall_max_token: llm.overall_max_token
        };
      });
    },
    editLLMModel(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) { },
    editLLMModelSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<IModelData[]>
    ) {
      state.llm_model = action.payload.map((llm: IModelData) => {
        return {
          value: llm.label,
          label: llm.label,
          key: llm.value,
          no: llm.no,
          overall_max_token: llm.overall_max_token
        };
      });
    },
    addLLMModel(state: Draft<IPrivateChatState>, action: PayloadAction<any>) { },
    addLLMModelSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<IModelData[]>
    ) {
      state.llm_model = action.payload.map((llm: IModelData) => {
        return {
          value: llm.label,
          label: llm.label,
          key: llm.value,
          no: llm.no,
          overall_max_token: llm.overall_max_token
        };
      });
    },
    deleteLLMModel(state: Draft<IPrivateChatState>, action: PayloadAction<any>) { },
    deleteLLMModelSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<IModelData[]>
    ) {
      state.llm_model = action.payload.map((llm: IModelData) => {
        return {
          value: llm.label,
          label: llm.label,
          key: llm.value,
          no: llm.no,
          overall_max_token: llm.overall_max_token
        };
      });
    },
    fetchPermissionTree(state: Draft<IPrivateChatState>, action: PayloadAction<any>) { },
    fetchPermissionTreeSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) {
      state.permission_tree = [
        {
          title: 'Select all',
          name: 'Select all',
          key: '0-0',
          disable: false,
          children: action.payload
        }
      ];
    },
    fetchApiTree(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) { },
    fetchApiTreeSuccess(
      state: Draft<IPrivateChatState>,
      action: PayloadAction<any>
    ) {
      state.api_tree = action.payload;
    },
    clearStoreChat(state) {
      state.private_chat = initialState.private_chat;
    },
    clearMessageWelcome(state) {
      state.mess_welcome = initialState.mess_welcome;
    },
    clearPermissionTree(state) {
      state.permission_tree = initialState.permission_tree;
    }
  },
});

// Actions
export const fetchMessageWelcome = PrivateChatSlice.actions.fetchMessageWelcome;
export const fetchMessageWelcomeSuccess =
  PrivateChatSlice.actions.fetchMessageWelcomeSuccess;
export const fetchMessageWelcomeFailure =
  PrivateChatSlice.actions.fetchMessageWelcomeFailure;
export const fetchDataAnswer = PrivateChatSlice.actions.fetchAnswer;
export const fetchDataAnswerSuccess =
  PrivateChatSlice.actions.fetchAnswerSuccess;
export const fetchDataAnswerFailure =
  PrivateChatSlice.actions.fetchAnswerFailure;
export const fetchAnswerWebosAPI = PrivateChatSlice.actions.fetchAnswerWebosAPI;
export const fetchAnswerWebosAPISuccess =
  PrivateChatSlice.actions.fetchAnswerWebosAPISuccess;
export const fetchAnswerWebosAPIFailure =
  PrivateChatSlice.actions.fetchAnswerWebosAPIFailure;
export const fetchDataLLMModel = PrivateChatSlice.actions.fetchDataLLMModel;
export const fetchDataLLMModelSuccess =
  PrivateChatSlice.actions.fetchDataLLMModelSuccess;
export const fetchPermissionTree = PrivateChatSlice.actions.fetchPermissionTree;
export const fetchPermissionTreeSuccess =
  PrivateChatSlice.actions.fetchPermissionTreeSuccess;
export const fetchApiTree = PrivateChatSlice.actions.fetchApiTree;
export const fetchApiTreeSuccess = PrivateChatSlice.actions.fetchApiTreeSuccess;
export const editLLMModel = PrivateChatSlice.actions.editLLMModel;
export const editLLMModelSuccess = PrivateChatSlice.actions.editLLMModelSuccess;
export const addLLMModel = PrivateChatSlice.actions.addLLMModel;
export const addLLMModelSuccess = PrivateChatSlice.actions.addLLMModelSuccess;
export const deleteLLMModel = PrivateChatSlice.actions.deleteLLMModel;
export const deleteLLMModelSuccess = PrivateChatSlice.actions.deleteLLMModelSuccess;
export const clearStoreChat = PrivateChatSlice.actions.clearStoreChat;
export const clearMessageWelcome = PrivateChatSlice.actions.clearMessageWelcome;
export const clearPermissionTree = PrivateChatSlice.actions.clearPermissionTree;

// Selectors
export const getDataAnswer = (state: RootState) =>
  state.private_chat.private_chat;
export const getDataMessageWelcome = (state: RootState) =>
  state.private_chat.mess_welcome;
export const getSessionHistory = (state: RootState) =>
  state.private_chat.private_chat.session_history;
export const getDataLLMModel = (state: RootState) =>
  state.private_chat.llm_model;
export const getPermissionTree = (state: RootState) =>
  state.private_chat.permission_tree;
export const getApiTree = (state: RootState) => state.private_chat.api_tree;
export const getMaxToken = (state: RootState) => state.private_chat.mess_welcome.max_token;
export const getWordsRemain = (state: RootState) => state.private_chat.mess_welcome.words_remain;

// Reducer
const PrivateChatReducer = PrivateChatSlice.reducer;
export default PrivateChatReducer;
